import _plugin_vue_export_helper_default from "../../../_virtual/_plugin-vue_export-helper.js";
import { createElementBlock, openBlock, renderSlot } from "vue";
//#region src/components/controls/control_event.vue
/**
* Control that is used to display an event of a component.
*/
var _sfc_main = { name: "DtcControlEvent" };
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
	return openBlock(), createElementBlock("div", null, [renderSlot(_ctx.$slots, "default")]);
}
var control_event_default = /* @__PURE__ */ _plugin_vue_export_helper_default(_sfc_main, [["render", _sfc_render]]);
//#endregion
export { control_event_default as default };

//# sourceMappingURL=control_event.vue.js.map